"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7069],{

/***/ 17069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M18 7.5V6h3c.6 0 1-.4 1-1s-.4-1-1-1h-3V3c0-.6-.4-1-1-1s-1 .4-1 1v1h-4V3c0-.6-.4-1-1-1s-1 .4-1 1v1H3c-.6 0-1 .4-1 1s.4 1 1 1h7v1.5l-7.6 5.7c-.4.3-.5.9-.2 1.4l2 3c.2.4.8.5 1.2.3l.6-.3V21c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-3.4l.6.3c.5.2 1 .1 1.3-.3l2-3c.3-.4.2-1-.2-1.4L12 7.5V6h4v2c0 .3.1.6.4.8l4 3c.2.1.4.2.6.2.3 0 .6-.1.8-.4.3-.4.2-1.1-.2-1.4L18 7.5zm-7 1.7l2.1 1.6c-.6.5-1.3.7-2.1.7s-1.5-.2-2.1-.7L11 9.2zm5.7 6.5l-1.2-.6c-.3-.2-.7-.1-1 0-.3.2-.5.6-.5.9v4H8v-4c0-.3-.2-.7-.5-.9-.3-.2-.7-.2-1 0l-1.2.6-1-1.5L7.2 12c1 .9 2.4 1.4 3.8 1.4s2.7-.5 3.8-1.4l2.9 2.2-1 1.5z"
}), "Cloakroom"));


/***/ })

}]);